var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"cat-SectionPanel_DetailIcon",on:{"click":function($event){$event.preventDefault();return _vm.showDetailModal.apply(null, arguments)}}},[_c('img',{attrs:{"src":require("common/icon-detail.svg"),"alt":"icon-detail"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }